import { cashierCtrl } from '../../cashier.controller';
import { IUICashierFormValues } from '../../cashier.interface';
import CashierActionButton, { ActionType } from '../../components/CashierActionButton';
import CashierMultipleCard, { useCashierMultipleCardRef } from './MultipleCardPayment';
type Props = {
  enableCardFee?: IUICashierFormValues['chargeFee'];
  feeCreditCard?: IUICashierFormValues['feeCreditCard'];
  feeCreditCardAmount?: IUICashierFormValues['feeCreditCardAmount'];
};
const CashierMultiCards = ({ enableCardFee, feeCreditCard, feeCreditCardAmount }: Props) => {
  const ref = useCashierMultipleCardRef();
  const onOpen = async () => {
    cashierCtrl.saveTicketPaymentWithCallBack((billId) => {
      if (billId) ref.current?.open(billId);
    });
  };
  return (
    <>
      <CashierActionButton
        type={ActionType.MULTI_CARDS}
        onClick={onOpen}
      />
      <CashierMultipleCard ref={ref}
        enableCardFee={enableCardFee}
        feeCreditCard={feeCreditCard}
        feeCreditCardAmount={feeCreditCardAmount}
      />
    </>
  );
};

export default CashierMultiCards;
